import React, { Component } from 'react'
import { fetchSignedMessage, getSessionValue, businessIdHeader, cssFormInputButton, cssFormInputLabel, cssFormInputTextArea, cssFormCheckBox, cssTableCheckBox, getMethod, isLoggedIn, checkBox, textField, putMethod, numberField, httpOKsuccess } from './Library'
import Logo from '../img/logo.png';
import { NavMenu } from '../components/NavMenu';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import ReactDOM from 'react-dom';
import { format } from 'date-fns';
import ShowHelp from '../img/help-icon.png';
import HideHelp from '../img/help-close-icon.png';

export class ContactRequests extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contactRequestsData: [],
            business: null,
            loading: true
        }
    }
    toggleHelp = (event) => {
        this.setState({
            helpVisible: !this.state.helpVisible
        });
    }

    async componentDidMount() {
        await isLoggedIn();
        this.getContactRequestsData();
    }

    async getContactRequestsData() {
        try {
            const businessId = getSessionValue(businessIdHeader);
            const response = await fetchSignedMessage(null, 'business/' + businessId + '/contactrequests', getMethod);
            const businessResponse = await fetchSignedMessage(null, 'business/' + businessId, getMethod);
            const data = await response.json();
            const businessData = await businessResponse.json();

            this.setState({ contactRequestsData: data });
            this.setState({ business: businessData, loading: false });
        }
        catch (error) {
            console.log(error);
            const networkErrorEmail = "mailto:tech@receiptsandrewards.com?subject=Login%20-%20Network%20Error&body=A%20User%20is%20unable%20to%20logon%20to%20" + window.location.host;
            var messageLabel = document.getElementById("errorMessage");
            ReactDOM.render(<label className={cssFormInputLabel} >There appears to be a network error. Please <a href={networkErrorEmail}>contact Receipts and Rewards</a> and we will fix it.</label>, messageLabel);
            this.setState({ loading: false, buttonDisabled: false });
        }
    }

    handleSubmit = (event) => {

        var responseLabel = document.getElementById("response");
            event.preventDefault();

            fetchSignedMessage(JSON.stringify(this.state.contactRequestsData), "contactrequest", putMethod).then(response => {
                if (response.status == httpOKsuccess) {
                    ReactDOM.render(<label className={cssFormInputLabel}>Contact Request Updates Saved.</label>, responseLabel);
                    this.setState({ loading: false, submitButtonDisabled: false });
                } else {
                    ReactDOM.render(<label className={cssFormInputLabel}>Contact Request Updates Saving failed. Please try again later.</label>, responseLabel);
                    this.setState({ loading: false, submitButtonDisabled: false });
                }
            }).catch(error => {
                this.setState({ loading: false, submitButtonDisabled: false });
                ReactDOM.render(<label className={cssFormInputLabel}>Contact Request Updates Saving failed. Please try again later.</label>, responseLabel);
                this.setState({ loading: false, submitButtonDisabled: false });
            });

        }

    handleContactRequestChange = (elementIndex) => (event) => {

        let contactRequestsData = this.state.contactRequestsData.map((item, i) => {
            if (elementIndex !== i) return item
            return { ...item, [event.target.name]: event.target.type === numberField ? Number(event.target.value) : (event.target.type === checkBox ? event.target.checked : event.target.value) }
        })

        this.setState({ contactRequestsData })
    }

    render() {
        return (
            <>

                <form onSubmit={this.handleSubmit }>
                    <NavMenu />
                    <table>
                    <tr><th>Email Address</th><th>Phone Number</th><th>First Name</th><th>Last Name</th><th>Business Name</th><th>Notes</th><th>Date Received</th><th>Processed</th></tr>
                    {
                        this.state.contactRequestsData.map((contactRequest, i) => (
                            <tr id={contactRequest.contactRequestId}>
                                <td>{contactRequest.consumer.email}</td>
                                <td>{contactRequest.consumer.phone}</td>
                                <td>{contactRequest.consumer.firstName}</td>
                                <td>{contactRequest.consumer.lastName}</td>
                                <td>{contactRequest.consumer.businessName}</td>
                                <td><textarea className={cssFormInputTextArea} type={textField} maxLength="2000" name="notes" value={contactRequest.notes} onChange={this.handleContactRequestChange(i)} /></td>
                                <td>{format(new Date(contactRequest.dateCreated), 'dd-MMM-yy HH:mm')}</td>
                                <td className={cssTableCheckBox} >
                                    <input type={checkBox} className={cssFormCheckBox} name="processed" checked={contactRequest.processed} onChange={this.handleContactRequestChange(i)} /></td>
                            </tr>                            
                        ))
                        }
                    </table><input type="submit" className={cssFormInputButton} value="Save" disabled={this.state.submitButtonDisabled} />
                    <img src={this.state.helpVisible ? HideHelp : ShowHelp} className="btn-help" onClick={this.toggleHelp} />
                </form>
                <div id="errorMessage" /><div id="response" />

                <p id="help" className={"collapse" + (this.state.helpVisible ? ".in" : "")}>
                    This form shows the list of people who have requested that you contact them. The processed check box can be used to indicate that they have been dealt with. </p>
                {this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
            </>
        );
    }

}